import AutomatedCampaignData = App.Sms.Data.AutomatedCampaigns.AutomatedCampaignData;

export const campaignNodeEditorKey = Symbol() as InjectionKey<Readonly<AutomatedCampaignData>>;
